import { useLocation } from "react-router-dom";
import PrimaryNavbar from "./PrimaryNavbar";
import SecondaryNavbar from "./SecondaryNavbar";

export default function Navbar() {
  const { pathname } = useLocation();

  return pathname === "/" ? <PrimaryNavbar /> : <SecondaryNavbar />;
}
